<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="670px"
    :close-on-click-modal="false"
    :class="'app-main-inner'+(uploading?' not-click':'')"
    :append-to-body="true"
  >
    <div class="app-main-inner-row row-grid" style="display:flex;min-height:350px;padding:0">
      <cargo-ag-grid
        :locale-text-func="_i18nGridLocalText"
        :grid-options="gridOptions"
        :grid-params.sync="gridParams"
        :column-defs="columnDefs"
        :row-data="rowData"
        :enable-col-resize="true"
        style="width:100%"
        class="upload-table ag-theme-balham"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <span slot="footer" style="padding-right:30px">
      <el-upload
        action
        multiple
        :auto-upload="false"
        :show-file-list="false"
        :on-change="toChooseFile"
        style="float:left;margin-left:30px;margin-right:13px"
        no="1"
      >
        <el-button no="2" type="primary">{{ $t('SeaExport.SelectFile') }}</el-button>
      </el-upload>
      <el-button no="3" type="danger" style="float:left" @click="remove()">{{ $t('SeaExport.DeleteFile') }}</el-button>
      <el-button type="primary" no="4" @click="upload()">{{ $t('SeaExport.Upload') }}</el-button>
      <el-button no="5" @click="innerVisible=false">{{ $t('SeaExport.Close') }}</el-button>
    </span>

  </el-dialog>
</template>

<script>

import { AutoIncrementNum, DocumentManage } from '@/utils/commonUtil'
import { cacheName, cache } from '@/utils/cacheManager'
import { Job } from '@/class/model/booking/Job'
import { uploadStorage } from '@/api/storage'
import { getLoading } from '@/utils/utilBaseElement'
import { deleteCustomsInfoFileHandler, queryFileListByCustom } from '@/api/seaExport/file'
import { addBusinessDocumentHandler } from '@/api/businessDocument'
import URL from '@/api/urlTranslator'

export default {
  name: 'CargoCloudFileUpload',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true },
    customInfo: { type: Object, required: true },
    documentType: { type: String, required: true },
    lob: { type: String, default: '' },
    title: { type: String, default: '' },
    showAll: { type: Boolean, default: false },
    otherParam: { type: Object, required: false }, // 其他参数
    fileSize: { type: Number, required: false }, // 文件大小
    shouldEncodeUuid: { type: Boolean, default: false } // 是否对uuid进行、url编码
  },
  data() {
    return {
      innerVisible: false,
      user: {},
      storageURL: '',
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: this.rowClicked
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.FileName'),
          colId: 'fileName',
          field: 'fileName',
          width: 175,
          cellRenderer: params => {
            if (params.data.fileId) {
              return `<a href="${URL.common.findByFileId}/${
                params.data.fileId
              }?sessionId=${
                this.user.sessionId
              }" target="_blank" style="color:blue">${params.value}</a>`
            } else {
              return params.value
            }
          }
        },
        {
          headerName: this.$t('SeaExport.FileType'),
          colId: 'fileType',
          field: 'fileType',
          width: 115
        },
        {
          headerName: this.$t('SeaExport.FileSize'),
          colId: 'fileSize',
          field: 'fileSize',
          width: 115,
          cellRenderer: params => {
            return params.value ? (params.value / 1024).toFixed(2) + 'KB' : ''
          }
        },
        {
          headerName: this.$t('Message.UploadTime'),
          colId: 'dateCreated',
          field: 'dateCreated',
          width: 115,
          cellRenderer: params => {
            return params.value
          }
        },
        {
          headerName: this.$t('SeaExport.UploadProgress'),
          colId: 'fileId',
          field: 'fileId',
          width: 115,
          cellRenderer: params => {
            if (params.value) {
              return '<span style="color:green">上传完成</span>'
            }
            if (this.uploading) {
              return this.$t('Message.Uploading2')
            }
            return this.$t('Message.Waiting')
          }
        }
      ],
      rowData: [],
      gridApi: null,
      autoIncrementNum: new AutoIncrementNum(),
      documentManage: new DocumentManage(),
      docTypeMap: new Map(),
      uploading: false,
      loading: null,
      selectedFile: null
    }
  },
  computed: {
    finalLob() {
      return this.lob || this.job.lob
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.initData()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.$emit('uploadDone', this.rowData)
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    if (this.visible) {
      this.innerVisible = true
      await this.initData()
    }
  },
  beforeMount() {

  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async initData() {
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.user = cache.user
      this.storageURL = cache.config.get('StorageURL')
      if (this.showAll) {
        await this.toQuery()
      }
    },
    toQuery() {
      if (!this.customInfo) {
        return
      }
      let dt = 1000
      if (this.documentType === 'Oback') {
        dt = 1001
      }
      return queryFileListByCustom(this.customInfo.uuid, dt).then(res => {
        this.rowData = Array.from(res.data, p => {
          const fileName = p.fileName
          const dateCreated = p.dateCreated
          const fileType = p.fileType
          return {
            seq: this.autoIncrementNum.getNextNum(),
            fileId: p.documentId,
            dateCreated,
            fileName,
            fileType,
            uuid: p.uuid,
            fileSize: p.fileSize
          }
        })
      })
    },
    rowClicked(event) {
      if (event.data) {
        this.selectedFile = event.data
      }
    },
    toChooseFile(file) {
      if (this.fileSize && this.fileSize > 1) {
        if (file.size > this.fileSize) {
          this.$message.warning(this.$t('Message.N1Exceeds4MBCannotUploaded'))
          return
        }
      } else {
        if (file.size > 20 * 1024 * 1024) {
          this.$message.warning(this.$t('Message.N1Exceeds20MBCannotUploaded'))
          return
        }
      }
      let fileName = file.name
      if (this.customInfo.tenDigitCode) {
        fileName = this.customInfo.tenDigitCode + '_' + fileName
      }
      const fileType = fileName.substr(fileName.lastIndexOf('.') + 1)
      const params = { file: file.raw }
      if (this.job instanceof Job) {
        params.jobNo = this.job.jobNo
        params.mbl = this.job.mbl
      }
      params.uuid = this.shouldEncodeUuid ? encodeURIComponent(this.job.uuid) : this.job.uuid
      params.documentType = this.documentType
      params.createdBy = this.user.userId
      params.createChineseName = this.user.chineseName
      params.createEnglishName = this.user.englishName
      this.rowData.push({
        seq: this.autoIncrementNum.getNextNum(),
        fileId: '',
        fileName,
        documentType: this.documentType,
        customsInfoUuid: this.customInfo.uuid,
        fileType,
        fileSize: file.size,
        params
      })
    },
    remove() {
      if (!this.selectedFile) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(
        this.$t('common.tips.confirmDelete'),
        this.$t('common.tips.prompt'),
        {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }
      )
        .then(async() => {
          const row = this.selectedFile
          const uuids = []
          uuids.push(row.uuid)
          const success = await deleteCustomsInfoFileHandler(uuids).then(res => res.data)
          if (success === 0) {
            this.$message.warning(this.$t('Message.DeleteFileFailed'))
            return
          }
          await this.toQuery()
        })
        .catch(() => {})
    },
    async upload() {
      const rows = this.rowData.filter(p => !p.fileId)
      if (rows.length === 0) {
        return
      }
      this.loading = getLoading('upload-table')
      this.uploading = true
      this.gridApi.refreshCells({ force: true })
      try {
        await Promise.all(
          Array.from(rows, p => {
            const params = p.params
            params.documentType = this.documentType
            params.documentName = p.fileCategoryLabel || 'other'
            params.isShared = 'false'
            params.op = 'false'
            params.sales = 'false'
            params.all = 'false'
            params.customer = 'false'
            params.consignee = 'false'
            params.shipper = 'false'
            params.destinationAgent = 'false'
            params.bookingAgent = 'false'
            return uploadStorage(params).then(res => {
              p.fileId = res.data
              p.fileCategory = params.documentType
              p.fileCategoryLabel = params.documentName
              this.uploadDoneHandler(p)
            })
          })
        )
      } catch {
        const uploadSuccessCount = rows.filter(p => p.fileId).length
        const uploadFailCount = rows.filter(p => !p.fileId).length
        await this.$confirm(
          this.$t('Message.Upload0UploadFailure0', [uploadSuccessCount, uploadFailCount]),
          this.$t('common.tips.prompt'),
          {
            showClose: false,
            confirmButtonText: this.$t('common.btn.ok'),
            showCancelButton: false,
            type: 'warning'
          }
        )
      } finally {
        this.loading.close()
        this.uploading = false
        this.innerVisible = false
        this.gridApi.refreshCells({ force: true })
      }
    },
    uploadDoneHandler(data) {
      const bList = []
      const businessDocument = {}
      businessDocument.documentId = data.fileId
      businessDocument.fileName = data.fileName
      businessDocument.fileSize = data.fileSize
      businessDocument.fileType = data.fileType
      let dt = 0
      if (this.documentType === 'Oback') {
        dt = 1001
      } else if (this.documentType === 'csFile') {
        dt = 1000
      }
      businessDocument.documentCategory = dt
      businessDocument.customsInfoUuid = data.customsInfoUuid
      bList.push(businessDocument)
      addBusinessDocumentHandler(bList)
    }
  }
}
</script>

<style scoped>
.not-click {
  pointer-events: none;
}
</style>
